import React from 'react';

import { Button } from 'js/components/common/Button';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { launchGame } from 'js/components/common/Game/actions';
import { useNavigate } from 'js/hooks/navigate';

import style from './EnterDrawPopup.scss';

export const EnterDrawPopup = ({
    id,
    enterDrawParams: {
        isSuccessUpdateTag,
        successPopupTitleText,
        errorPopupTitleText,
        successPopupText,
        errorPopupText,
        successPopupCTAText,
        errorPopupCTAText,
        successCTACallback,
        ctaConfiguration,
        navigateUrl,
        gameCode
    }
}) => {
    const navigate = useNavigate();
    const closePopup = useOnClose(id);

    const handleClose = () => {
        if (isSuccessUpdateTag) {
            if (successCTACallback) {
                successCTACallback();
            }

            if (ctaConfiguration) {
                switch (ctaConfiguration) {
                    case 'navigate':
                        if (navigateUrl) {
                            navigate(navigateUrl);
                        }

                        break;

                    case 'gameLaunch':
                        launchGame({ code: gameCode });
                        break;

                    default:
                        break;
                }
            }
        }

        closePopup();
    };

    const [title, text, ctaText] = isSuccessUpdateTag
        ? [successPopupTitleText, successPopupText, successPopupCTAText]
        : [errorPopupTitleText, errorPopupText, errorPopupCTAText];

    return (
        <ManagedPopup
            isModal
            className={style.popup}
            title={title}
        >
            <p
                data-testid="EnterDrawPopup__text"
                className={style.popupBody}
            >
                {text}
            </p>

            <Button
                view="secondary"
                data-testid="EnterDrawPopup__button"
                className={style.popupButton}
                onClick={handleClose}
            >
                {ctaText}
            </Button>
        </ManagedPopup>
    );
};
